var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneRecorded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 0H8C3.58172 0 0 3.58172 0 8V68C0 72.4183 3.58172 76 8 76H68C72.4183 76 76 72.4183 76 68V8C76 3.58172 72.4183 0 68 0Z",
    fill: "#FCEBE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.295 37.2955L38.7041 21.7046",
    stroke: "#F78670",
    strokeWidth: 4.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.295 21.7046L38.7041 37.2955",
    stroke: "#F78670",
    strokeWidth: 4.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1054 23.7357C27.2918 22.1095 25.5915 20.7942 23.5032 21.0268C21.635 21.2343 18.8613 21.9291 16.9702 24.2072C15.0289 26.5469 14.305 30.1957 15.7956 35.6627C17.3874 41.4947 19.7511 47.2444 22.6896 51.8831C25.6061 56.4884 29.1986 60.1748 33.3199 61.5882C36.9646 62.8379 39.7518 62.3163 41.7848 60.9436C43.7458 59.6199 44.8223 57.6285 45.3794 56.2496C46.0031 54.7057 45.5921 53.0983 44.7785 51.9133L41.7775 47.549C41.1145 46.5846 40.1601 45.8579 39.054 45.4755C37.948 45.0931 36.7485 45.0751 35.6315 45.4241L31.4841 46.7207C31.3531 46.7656 31.2118 46.7711 31.0777 46.7364C30.9436 46.7017 30.8227 46.6284 30.7299 46.5257C28.8836 44.3633 26.8151 41.3476 26.2528 38.2955C26.235 38.214 26.2473 38.1288 26.2873 38.0556C26.8975 37.0302 27.9469 35.8682 28.9921 34.8511C30.7622 33.1279 31.4329 30.3887 30.2647 28.0542L28.1054 23.7357Z",
    fill: "#02475E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneRecorded);
export default __webpack_public_path__ + "static/media/PhoneRecorded.12a28ade0656fe2aa457c12904eeca8a.svg";
export { ForwardRef as ReactComponent };